import { useEffect, useState } from "react";

const navLinks = [
  { id: "overview", label: "版本一览" },
  { id: "glossary", label: "术语词典" },
  { id: "compare", label: "版本对比" },
  { id: "filter", label: "速查筛选" },
  { id: "faq", label: "常见问题" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          className={`group flex items-center gap-2.5 font-heading text-base font-bold tracking-wide transition-colors ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg" aria-hidden="true"></i>
          </span>
          <span>
            嫂子的诱惑
            <span className="ml-1.5 text-xs font-normal opacity-80">字幕索引</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="页面分区导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label="打开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors md:hidden ${
            scrolled
              ? "border-background-300 text-foreground-900 hover:bg-background-100"
              : "border-background-50/40 text-background-50 hover:bg-background-50/15"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-[1200px] flex-col px-4 py-2" aria-label="移动端分区导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}